import React, { Component } from "react";

import { withFormik } from "formik";

import * as Yup from "yup";

import { Button } from "react-bootstrap";
import SaveIcon from "@material-ui/icons/Save";
import {
  Section,
  Wrapper,
  getRowItemObject,
  renderRowWithSingleItem,
} from "../../../../../../../common/FormUtils";
import { Author } from "../../../../../../../../types/Author";
import { Option } from "../../../../../../../../types/Question";

type Props = {
  onChageFormToEditMode: Function;
  onToggleFullScreenDialog;
  setFieldValue: Function;
  handleSubmit: any;
  onRemoveItem: Function;
  values: any;
  errors: Object;
  onEditItem: any;
  isSubmitting: boolean;
  mode: string;
  item: any | null;
  authors: Author[];
  dayPlanID: string;
  planID: string;
};

type State = {
  isSaleConfirmationDialogOpen: boolean;
  shouldBlockFormSubmit: boolean;
  isOptionFormDialogVisible: boolean;
  mode: string;
};

class OptionForm extends Component<Props, State> {
  state = {
    isSaleConfirmationDialogOpen: false,
    shouldBlockFormSubmit: false,
    isOptionFormDialogVisible: false,
    mode: "",
  };

  handleBlockFormSubmit = (value: boolean): void => {
    this.setState({
      shouldBlockFormSubmit: value,
    });
  };

  renderOption = () => {
    const salePriceInputFieldData = getRowItemObject(
      "Option",
      "Type the option",
      "string",
      "description"
    );

    return renderRowWithSingleItem(salePriceInputFieldData, this.props);
  };

  renderSaveButton = () => {
    return (
      <Button
        style={{ marginBottom: 12 }}
        color="primary"
        variant="outlined"
        onClick={() => {
          console.log("Submitting");
          this.props.handleSubmit();
        }}
      >
        <SaveIcon />
      </Button>
    );
  };

  render() {
    return (
      <Wrapper>
        <Section>
          {this.renderOption()}

          {this.renderSaveButton()}
        </Section>
      </Wrapper>
    );
  }
}

const CustomForm = withFormik({
  mapPropsToValues: (props: any): Option => {
    const { item, dayPlanID, planID } = props;
    return {
      id: item?.id || "",
      description: item?.description || "",
    };
  },

  validationSchema: ({ item, mode }) =>
    Yup.lazy((values) =>
      Yup.object().shape({
        description: Yup.string().required("La descripción es requerida."),
      })
    ),

  handleSubmit(values, { setSubmitting, props }) {
    const { onCreateItem, onEditItem, mode, onToggleFullScreenDialog } = props;

    const properCallback = mode === "edit" ? onEditItem : onCreateItem;

    properCallback({
      ...values,
    });
    setSubmitting(false);
  },
})(OptionForm);

export default CustomForm;
